export const MARIN_ROUTES = {
  home: "/",
  dashboard: "/",
  map: "/map",
  reports: "/reports",
  analytics: "/analytics",
  directory: "/directory",
  directoryUser: "/directory/:userId",
  timeline: "/timeline",
  visitors: "/visitors",
  workplaceRequests: "/workplace-requests",
  settings: "/settings",
  admin: "/admin",
  questionnaire: "/questionnaire",
  signup: "/signup",
  notFound: "/404"
};

export const ADMIN_ROUTES = {
  adminHome: MARIN_ROUTES.admin,

  // Reservations
  reservations: `${MARIN_ROUTES.admin}/reservations`,
  reservationsPending: `${MARIN_ROUTES.admin}/reservations/pending`,
  reservationsOccupied: `${MARIN_ROUTES.admin}/reservations/occupied`,

  // Attendance
  attendance: `${MARIN_ROUTES.admin}/attendance`,
  attendancePending: `${MARIN_ROUTES.admin}/attendance/pending`,
  attendanceAccepted: `${MARIN_ROUTES.admin}/attendance/accepted`,
  attendanceRejected: `${MARIN_ROUTES.admin}/attendance/rejected`,
  attendancePolicies: `${MARIN_ROUTES.admin}/attendance/policies`,

  // Visitors
  visitors: `${MARIN_ROUTES.admin}/visitors`,
  visitorsStations: `${MARIN_ROUTES.admin}/visitors/stations`,
  visitorsInvitations: `${MARIN_ROUTES.admin}/visitors/invitations`,
  visitorsVisits: `${MARIN_ROUTES.admin}/visitors/visits`,

  // Activity
  activity: `${MARIN_ROUTES.admin}/activity`,
  activityLog: `${MARIN_ROUTES.admin}/activity/log`,
  activityDirectoryChanges: `${MARIN_ROUTES.admin}/activity/directory-changes`,

  // Station PIN (Tactic staff only)
  stationPin: `${MARIN_ROUTES.admin}/station-pin`
};

export const SETUP_ROUTES = {
  offices: "/setup/offices",
  resources: "/setup/resources",
  teams: "/setup/teams",
  users: "/setup/users"
};

export const SETTINGS_ROUTES = {
  settingsHome: MARIN_ROUTES.settings,

  // Profile
  profile: `${MARIN_ROUTES.settings}/profile`,

  // Attendance
  attendance: `${MARIN_ROUTES.settings}/attendance`,
  attendanceRequests: `${MARIN_ROUTES.settings}/attendance/requests`,
  attendancePolicies: `${MARIN_ROUTES.settings}/attendance/policies`,
  attendanceHolidays: `${MARIN_ROUTES.settings}/attendance/holidays`,

  // Favorites
  favorites: `${MARIN_ROUTES.settings}/favorites`,

  // Organization settings
  organization: `${MARIN_ROUTES.settings}/organization`,
  organizationAuthentication: `${MARIN_ROUTES.settings}/organization/authentication`,
  organizationWifi: `${MARIN_ROUTES.settings}/organization/wifi`,
  organizationReservations: `${MARIN_ROUTES.settings}/organization/reservations`,
  organizationTheme: `${MARIN_ROUTES.settings}/organization/theme`,
  organizationMap: `${MARIN_ROUTES.settings}/organization/map`,
  organizationMobileApp: `${MARIN_ROUTES.settings}/organization/mobile-app`,
  organizationAi: `${MARIN_ROUTES.settings}/organization/ai`,
  organizationSsoSetup: "/sso-setup",
  organizationSsoConnection: "/sso-connection",
  organizationStationPin: `${MARIN_ROUTES.settings}/organization/station-pin`,

  // Facilities
  facilities: `${MARIN_ROUTES.settings}/offices`,
  facilitiesBuildings: `${MARIN_ROUTES.settings}/offices/buildings`,
  facilitiesDivisions: `${MARIN_ROUTES.settings}/offices/divisions`,

  // Manage office
  facilitiesBuildingGeneral: `${MARIN_ROUTES.settings}/offices/building/:officeId`,
  facilitiesBuildingHours: `${MARIN_ROUTES.settings}/offices/building/:officeId/hours`,
  facilitiesBuildingHoliday: `${MARIN_ROUTES.settings}/offices/building/:officeId/holiday`,
  facilitiesBuildingFloors: `${MARIN_ROUTES.settings}/offices/building/:officeId/floors`,
  facilitiesBuildingWorkspaces: `${MARIN_ROUTES.settings}/offices/building/:officeId/workspaces`,
  facilitiesBuildingMeetingRooms: `${MARIN_ROUTES.settings}/offices/building/:officeId/meeting-rooms`,
  facilitiesBuildingParking: `${MARIN_ROUTES.settings}/offices/building/:officeId/parking`,
  facilitiesBuildingSettings: `${MARIN_ROUTES.settings}/offices/building/:officeId/settings`,
  facilitiesBuildingIntegrations: `${MARIN_ROUTES.settings}/offices/building/:officeId/integrations`,
  facilitiesBuildingDefaultTime: `${MARIN_ROUTES.settings}/offices/building/:officeId/default-time`,
  facilitiesBuildingDocuments: `${MARIN_ROUTES.settings}/offices/building/:officeId/documents`,

  // Health
  health: `${MARIN_ROUTES.settings}/health`,
  healthVaccination: `${MARIN_ROUTES.settings}/health/vaccinations/:id`,
  healthTest: `${MARIN_ROUTES.settings}/health/tests/:id`,
  healthAdmin: `${MARIN_ROUTES.settings}/health/admin`,
  healthAdminUsers: `${MARIN_ROUTES.settings}/health/admin/users`,
  healthAdminQuestionnaires: `${MARIN_ROUTES.settings}/health/admin/questionnaires`,
  healthAdminSettings: `${MARIN_ROUTES.settings}/health/admin/settings`,

  // Amenities
  amenities: `${MARIN_ROUTES.settings}/amenities`,
  // Zones (organisation allocations drawn on floor maps) and their regions
  zones: `${MARIN_ROUTES.settings}/zones`,
  zoneDetail: `${MARIN_ROUTES.settings}/zones/:zoneId`,

  // Workplace Requests
  workplaceRequests: `${MARIN_ROUTES.settings}/workplace-requests`,
  workplaceRequestsCategories: `${MARIN_ROUTES.settings}/workplace-requests/categories`,
  workplaceRequestsRequests: `${MARIN_ROUTES.settings}/workplace-requests/requests`,
  workplaceRequestsPublicLinks: `${MARIN_ROUTES.settings}/workplace-requests/public-links`,

  // User and Teams
  usersAndTeamsUsers: `${MARIN_ROUTES.settings}/users`,
  usersAndTeamsUserDetail: `${MARIN_ROUTES.settings}/users/:userId`,
  usersAndTeamsTeams: `${MARIN_ROUTES.settings}/users/teams`,
  usersAndTeamsTeamManagers: `${MARIN_ROUTES.settings}/users/team-managers`,
  usersAndTeamsBulkImports: `${MARIN_ROUTES.settings}/users/bulk-imports`,
  usersAndTeamsPermissionGroups: `${MARIN_ROUTES.settings}/users/permission-groups`,

  // News and updates
  newsAndUpdates: `${MARIN_ROUTES.settings}/news`,

  // Pages
  pages: `${MARIN_ROUTES.settings}/pages`,

  // API Keys
  apiKeys: `${MARIN_ROUTES.settings}/api-keys`,
  apiKeysWebhooks: `${MARIN_ROUTES.settings}/api-keys/webhooks`,

  // Integration and apps
  integrations: `${MARIN_ROUTES.settings}/integrations`,
  integrationsPersonalIntegrations: `${MARIN_ROUTES.settings}/integrations`,
  integrationsOrganizationIntegrations: `${MARIN_ROUTES.settings}/integrations/organization`,
  integrationsSettings: `${MARIN_ROUTES.settings}/integrations/settings`,
  integrationsConnectedApps: `${MARIN_ROUTES.settings}/integrations/connected-apps`,

  // Account (Tactic staff only)
  account: `${MARIN_ROUTES.settings}/account`,

  // Room Displays
  stations: `${MARIN_ROUTES.settings}/stations`,

  // Wayfinder Displays
  wayfinders: `${MARIN_ROUTES.settings}/wayfinders`,

  // Visitor Management
  visitorManagement: `${MARIN_ROUTES.settings}/visitor-management`,
  visitorManagementVisitorStations: `${MARIN_ROUTES.settings}/visitor-management/visitor-stations`,
  visitorManagementTypes: `${MARIN_ROUTES.settings}/visitor-management/types`,
  visitorManagementSettings: `${MARIN_ROUTES.settings}/visitor-management/settings`,
  visitorManagementWatchlist: `${MARIN_ROUTES.settings}/visitor-management/watchlist`,
  visitorManagementDeliveries: `${MARIN_ROUTES.settings}/visitor-management/deliveries`,
  visitorManagementDocuments: `${MARIN_ROUTES.settings}/visitor-management/documents`
};
